import httpService from "./httpService";

export default {
  getAllCompanies: async () => httpService.get(`/company/allCompanies`),
  getCompanyByPakServiceId: async serviceId =>
    httpService.get(`/companyResolving/resolveCompanyByServiceId?companyId=${serviceId}`),
  getName: async id => httpService.get(`/company/${id}/name`),
  getSendBirdSessionToken: async companyUserId => httpService.get(`/company/${companyUserId}/sendBirdSessionToken`)
};
